import { useEffect } from 'react'

interface LogOptions {
    prefix?: string
    css?: string
}

/**
 * Will log the values in case they change.
 * If you set prefix it will log it before the values.
 * If you set css it will apply that css to the log message.
 */
export const useLogOnChange = (values: any[], options: LogOptions = {}): void => {
    useEffect(() => {
        const { prefix, css } = options
        const args: any[] = [...values]
        if (css) {
            console.log(`%c${prefix || ''}[${args.map(e => `${e}`).join(', ')}]`, css)
        } else {
            if (prefix) args.unshift(prefix)
            console.log(...args)
        }
    }, values)
}

export default useLogOnChange
